export { Filters } from './statusConstants'

export const MY_TEAMS_ADVISOR = 'my-teams'
export const ZET_APP = 'zet-app'
export const TERMS_AND_CONDITIONS = {
  zetAgentTermsOfUse: 'https://www.zetapp.in/terms-of-use',
  zetAgentPrivacyPolicy: 'https://www.zetapp.in/privacy-policy',
  zetEndUserTermsOfUse: 'https://www.zetapp.in/end-user-terms-of-use',
  zetEndUserPrivacyPolicy: 'https://www.zetapp.in/end-user-privacy-policy',
  advisorAgentTermsOfUse: 'https://www.myteams.co.in/terms-of-use',
  advisorAgentPrivacyPolicy: 'https://www.myteams.co.in/privacy-policy',
}

export const HOME_BANNER = {
  uri: `https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/homepageBanners/ZET_Magnet_PostLaunch_Homepage_1.jpg?datetime=${new Date().getMilliseconds()}`,
  onClick: '/category?categoryId=18&routeName=category',
}

export const GLOBAL_BANNER = {
  uri: 'https://onecode-asset.s3.ap-south-1.amazonaws.com/ZET/Homepage+Banner/TopBannerZET_3.png',
}

export * from './appSession'
